// extracted by mini-css-extract-plugin
export default {"removedMessage":"RemovedMessage_removedMessage__k9PQC","left":"RemovedMessage_left__g2QBW","right":"RemovedMessage_right__0xf9h","icon":"RemovedMessage_icon__nD8FX"};